// Resolved on demand per code rather than eagerly importing all ~266 flags at module load —
// this file is reachable from the countries Vuex module, which is combined into the store (and
// so loaded) at app boot regardless of whether any flag is ever rendered on the current page.
export default async function getFlagUrl(alpha2Code) {
    try {
        const mod = await import(`./${alpha2Code}.svg?url`);
        return mod.default;
    } catch {
        return null;
    }
}
